import React, { FC, useState }                      from "react";
import { useDispatch, useSelector }                 from "react-redux";
import { Button, Icon, Input, Modal, Radio, Table } from "semantic-ui-react";
import GetCustomers                                 from "../../../application/usecase/customer/GetCustomers";
import CustomerSearchValue                          from "../../../domain/customer/criteria/CustomerSearchValue";
import CustomerSortType                             from "../../../domain/customer/criteria/CustomerSortType";
import Customer                                     from "../../../domain/customer/Customer";
import Customers                                    from "../../../domain/customer/Customers";
import CurrentPage                                  from "../../../domain/fundamentals/pagination/CurrentPage";
import ReservationRepository                        from "../../../domain/reservation/ReservationRepository";
import { ResKaState }                               from "../../../index";
import ReservationDataSource
                                                    from "../../../infrastructure/datasource/reservation/ReservationDataSource";
import BottomSection                                from "../common/layout/BottomSection";
import ListTotalCount                               from "../common/layout/ListTotalCount";
import TopSection                                   from "../common/layout/TopSection";
import ListPagination                               from "../common/ListPagination";

const ReservationCustomerSelector: FC = () => {
  const [open, setOpen] = useState(false);
  const [selected, select] = useState(new Customer());
  const customer: Customer = useSelector((state: ResKaState) => state.reservation.customer);
  const customers: Customers = useSelector((state: ResKaState) => state.customers);
  const repository: ReservationRepository = new ReservationDataSource(useDispatch());
  const getCustomers: GetCustomers = new GetCustomers(useDispatch());

  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ async () => {
          await getCustomers.execute(new CurrentPage(), new CustomerSearchValue(), CustomerSortType.NONE);
          select(new Customer());
          setOpen(true);
        } }
      >
        <Icon name="user"/>
        {
          isNaN(customer.id.value)
            ?
            "予約する顧客を選択する"
            :
            `${ customer.detail.name.lastName.value } ${ customer.detail.name.firstName.value }`
        }
      </Button>

      <Modal
        open={ open }
      >
        <Modal.Header>予約する顧客の選択</Modal.Header>

        <Modal.Content>
          <TopSection>
            <Input
              icon="search"
              placeholder="顧客検索"
              defaultValue={ customers.search.value }
              onChange={ (event, data) => setTimeout(() => getCustomers.execute(customers.pagination.current, new CustomerSearchValue(data.value), customers.sortType), 500) }
            />
          </TopSection>

          {
            customers.isEmpty()
              ?
              <p>顧客情報がありません。</p>
              :
              <>
                <TopSection>
                  <Button
                    onClick={ () => {
                      repository.setReservationCustomer(new Customer());
                      setOpen(false);
                    } }
                  >
                    選択済みの顧客を解除する
                  </Button>
                </TopSection>
                <ListTotalCount>{ customers.count.toString() }</ListTotalCount>
                <Table
                  striped
                  selectable
                >
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>選択</Table.HeaderCell>
                      <Table.HeaderCell>顧客番号</Table.HeaderCell>
                      <Table.HeaderCell>顧客氏名</Table.HeaderCell>
                      <Table.HeaderCell>性別</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {
                      customers.toList().map(customer => (
                        <Table.Row onClick={ () => select(customer) }>
                          <Table.Cell width={ 2 }>
                            <Radio
                              name="ReservationCustomerSelector"
                              checked={ selected.id.equals(customer.id) }
                              onChange={ () => select(customer) }
                            />
                          </Table.Cell>
                          <Table.Cell>{ customer.detail.number.value }</Table.Cell>
                          <Table.Cell>{ `${ customer.detail.name.lastName.value } ${ customer.detail.name.firstName.value }` }</Table.Cell>
                          <Table.Cell>{ customer.detail.genderLabel() }</Table.Cell>
                        </Table.Row>
                      ))
                    }
                  </Table.Body>
                </Table>

                <BottomSection>
                  <ListPagination
                    currentPage={ customers.pagination.current }
                    totalPage={ customers.pagination.total }
                    onChangePage={ currentPage => getCustomers.execute(currentPage, customers.search, customers.sortType) }
                  />
                </BottomSection>
              </>
          }
        </Modal.Content>

        <Modal.Actions>
          <Button
            icon
            labelPosition="left"
            disabled={ isNaN(selected.id.value) }
            positive={ !isNaN(selected.id.value) }
            onClick={ () => {
              repository.setReservationCustomer(selected);
              setOpen(false);
            } }
          >
            <Icon name="check"/>
            決定する
          </Button>

          <Button
            onClick={ () => setOpen(false) }
          >
            閉じる
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default ReservationCustomerSelector;
